export const cloneArray = array => {
    return array.slice(0);
};